// 应用配置文件
const config = {
    // 后端服务器地址
    API_BASE_URL: 'http://127.0.0.1:8000',//http://127.0.0.1:8000 http://100.119.98.47/

    // 默认头像路径
    DEFAULT_AVATAR: '@/assets/logo.png'
};

export default config;